export default "__VITE_ASSET__C$lXy60g__"